import React, { Component } from 'react';
import { playSoundSilent } from '../../utils/audioHelper';

class ProductBinDeleteDetail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            single_bin: '',
            range_start: '',
            range_end: '',
            binMessage: '',
            binInfo: '',
            cl_id: typeof(localStorage.getItem('headerClientId')) === 'undefined' ? 0 : localStorage.getItem('headerClientId'),
            userToken: localStorage.getItem('userToken')
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSingleChange = this.handleSingleChange.bind(this);
        this.handleRangeStartChange = this.handleRangeStartChange.bind(this);
        this.handleRangeEndChange = this.handleRangeEndChange.bind(this);
        this.deleteSingleBin = this.deleteSingleBin.bind(this);
        this.deleteRangeBins = this.deleteRangeBins.bind(this);
    }

    playGood() {
        playSoundSilent('good-audio-element');
    }

    playBad() {
        playSoundSilent('bad-audio-element');
    }

    playComplete() {
        playSoundSilent('complete-audio-element');
    }

    handleSingleChange(event) {
        this.setState({ single_bin: event.target.value });
    }

    handleRangeStartChange(event) {
        this.setState({ range_start: event.target.value });
    }

    handleRangeEndChange(event) {
        this.setState({ range_end: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
    }

    handleSingleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.deleteSingleBin();
        }
    }

    handleRangeStartKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            const rangeEndInput = document.getElementById('range_end');
            if (rangeEndInput) {
                rangeEndInput.focus();
            }
        }
    }

    handleRangeEndKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.deleteRangeBins();
        }
    }

    deleteSingleBin = () => {
        const singleBin = this.state.single_bin.trim();

        if (!singleBin) {
            this.setState({ binMessage: 'SCAN BIN TO DELETE', binInfo: '' });
            this.playBad();
            return;
        }

        const binJSON = JSON.stringify({
            bn_bin: singleBin
        });

        fetch(process.env.REACT_APP_NODE_ROOT_URL + '/products/bins/deletebin/' + this.state.cl_id, {
            method: 'post',
            body: binJSON,
            headers: {
                'Content-Type': 'application/json',
                'bwToken': this.state.userToken
            }
        })
        .then(res => res.json())
        .then((response) => {
            if (response && response.error) {
                this.setState({
                    binMessage: 'DELETE FAILED',
                    binInfo: response.error,
                    single_bin: ''
                });
                this.playBad();
                return;
            }

            const deleted = response && response.deleted ? response.deleted : 0;

            if (deleted > 0) {
                this.setState({
                    binMessage: 'BIN DELETED',
                    binInfo: singleBin + ' | Records deleted: ' + deleted,
                    single_bin: ''
                });
                this.playComplete();
            } else {
                this.setState({
                    binMessage: 'NO RECORDS FOUND',
                    binInfo: singleBin + ' | Records deleted: 0',
                    single_bin: ''
                });
                this.playBad();
            }
        })
        .catch((error) => {
            this.setState({
                binMessage: 'DELETE FAILED',
                binInfo: 'Unable to delete bin records.',
                single_bin: ''
            });
            this.playBad();
            console.log('delete single error: ' + error);
        });
    }

    deleteRangeBins = () => {
        const rangeStart = this.state.range_start.trim();
        const rangeEnd = this.state.range_end.trim();

        if (!rangeStart || !rangeEnd) {
            this.setState({ binMessage: 'SCAN RANGE START AND END', binInfo: '' });
            this.playBad();
            return;
        }

        const rangeJSON = JSON.stringify({
            bn_start: rangeStart,
            bn_end: rangeEnd
        });

        fetch(process.env.REACT_APP_NODE_ROOT_URL + '/products/bins/deleterange/' + this.state.cl_id, {
            method: 'post',
            body: rangeJSON,
            headers: {
                'Content-Type': 'application/json',
                'bwToken': this.state.userToken
            }
        })
        .then(res => res.json())
        .then((response) => {
            if (response && response.error) {
                this.setState({
                    binMessage: 'RANGE DELETE FAILED',
                    binInfo: response.error,
                    range_start: '',
                    range_end: ''
                });
                this.playBad();
                return;
            }

            const deleted = response && response.deleted ? response.deleted : 0;

            if (deleted > 0) {
                this.setState({
                    binMessage: 'RANGE DELETED',
                    binInfo: rangeStart + ' to ' + rangeEnd + ' | Records deleted: ' + deleted,
                    range_start: '',
                    range_end: ''
                });
                this.playGood();
            } else {
                this.setState({
                    binMessage: 'NO RECORDS FOUND IN RANGE',
                    binInfo: rangeStart + ' to ' + rangeEnd + ' | Records deleted: 0',
                    range_start: '',
                    range_end: ''
                });
                this.playBad();
            }
        })
        .catch((error) => {
            this.setState({
                binMessage: 'RANGE DELETE FAILED',
                binInfo: 'Unable to delete bin records for this range.',
                range_start: '',
                range_end: ''
            });
            this.playBad();
            console.log('delete range error: ' + error);
        });
    }

    render() {

        return (
            <div id="main">
                <div className="page-wrapper">
                    <div className="row page-titles">
                        <div className="col-md-12 align-self-center">
                            <h2 className="text-primary">Product Bin Delete</h2>
                        </div>
                    </div>

                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-body" name="card-order-list">
                                <div className="row">
                                    <div className="col-md-8">
                                        <h3>Scan one BIN to delete, or scan a BIN range to delete all bins in that range.</h3>
                                        <div className="binMessage" style={{ fontSize: 36 }}>{this.state.binMessage}</div>
                                        <div className="binInfo" style={{ fontSize: 24, marginBottom: 20 }}>{this.state.binInfo}</div>

                                        <form id="formBinDelete" onSubmit={this.handleSubmit}>
                                            <label style={{ fontSize: 22, display: 'block' }}>Single BIN Delete</label>
                                            <input
                                                type="text"
                                                autoFocus
                                                id="single_bin"
                                                name="single_bin"
                                                style={{ float: 'left', width: 320, fontSize: 36, marginRight: 12 }}
                                                className="single_bin"
                                                onKeyPress={this.handleSingleKeyPress}
                                                value={this.state.single_bin}
                                                onChange={this.handleSingleChange}
                                                placeholder="Scan single BIN"
                                            />

                                            <div style={{ clear: 'both', height: 24 }}></div>

                                            <label style={{ fontSize: 22, display: 'block' }}>Range Delete</label>
                                            <input
                                                type="text"
                                                id="range_start"
                                                name="range_start"
                                                style={{ float: 'left', width: 240, fontSize: 30, marginRight: 12 }}
                                                className="range_start"
                                                onKeyPress={this.handleRangeStartKeyPress}
                                                value={this.state.range_start}
                                                onChange={this.handleRangeStartChange}
                                                placeholder="Start BIN"
                                            />

                                            <input
                                                type="text"
                                                id="range_end"
                                                name="range_end"
                                                style={{ float: 'left', width: 240, fontSize: 30, marginRight: 12 }}
                                                className="range_end"
                                                onKeyPress={this.handleRangeEndKeyPress}
                                                value={this.state.range_end}
                                                onChange={this.handleRangeEndChange}
                                                placeholder="End BIN"
                                            />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="modalMain"></div>
                </div>

                <audio className="good-audio-element">
                    <source src={process.env.REACT_APP_ROOT_URL + '/sound/good-noise.mp3'}></source>
                </audio>

                <audio className="bad-audio-element">
                    <source src={process.env.REACT_APP_ROOT_URL + '/sound/bad-noise.mp3'}></source>
                </audio>

                <audio className="complete-audio-element">
                    <source src={process.env.REACT_APP_ROOT_URL + '/sound/complete.mp3'}></source>
                </audio>
            </div>
        );
    }
}

export default ProductBinDeleteDetail;
